import React, { useEffect, useState, createElement } from 'react';
import { ArrowRightIcon, CheckIcon, XIcon, UserIcon, BuildingIcon, TrendingUpIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function WebsiteLatenMakenOfZelfBouwenPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Website laten maken of zelf bouwen? | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Website laten maken of zelf bouwen? Vergelijk de voor- en nadelen van uitbesteden vs DIY. Ontdek welke optie het beste past bij jouw bedrijf en budget.';
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Website laten maken of zelf bouwen? | Noord',
      'og:description': 'Website laten maken of zelf bouwen? Vergelijk de voor- en nadelen van uitbesteden vs DIY.',
      'og:type': 'article',
      'og:url': 'https://noorddigital.nl/website-laten-maken-of-zelf-bouwen',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: 'Is een website builder goed genoeg voor mijn bedrijf?',
    a: 'Voor een eenvoudige online aanwezigheid kan een website builder voldoende zijn. Maar als je serieus wilt groeien, meer klanten wilt aantrekken via Google en een professionele uitstraling belangrijk vindt, dan is een op maat gemaakte website de betere investering.'
  }, {
    q: 'Wat kost een webdesigner?',
    a: 'Een professionele bedrijfswebsite kost gemiddeld tussen de €1.500 en €3.500. Dit is inclusief design, ontwikkeling, SEO-basis en contentplaatsing. Bij Noord Digital werken we met transparante prijzen zonder verborgen kosten.'
  }, {
    q: 'Kan ik later overstappen van een website builder naar WordPress?',
    a: 'Ja, dat kan. Houd er wel rekening mee dat content en design opnieuw moeten worden opgebouwd. Het is vaak voordeliger om direct met de juiste oplossing te starten dan later over te stappen.'
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-2315" data-mp="qrg4e9y0tbu6">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-2316" data-mp="28qe2ehtq7dlq">
        <div className="absolute inset-0 pointer-events-none" data-id="element-2317" data-mp="2doyv7w6nev05">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-2318" data-mp="2igyz1zpua820" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-2319" data-mp="2mik819z9626x" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-2320" data-mp="1ptcv2qcp91em" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2321" data-mp="23svr4ks8kmak">
          {/* Breadcrumb */}
          <nav className="flex items-center justify-center gap-2 text-sm mb-8 animate-fade-in-up" data-id="element-2322" data-mp="3a7d7hgf32s6a">
            <a href="#/" className="text-navy-400 hover:text-white transition-colors" data-id="element-2323" data-mp="3f5epdy0rwlg6">
              Home
            </a>
            <span className="text-navy-500" data-id="element-2324" data-mp="38r94o982zo6x">/</span>
            <a href="#/kennisbank" className="text-navy-400 hover:text-white transition-colors" data-id="element-2325" data-mp="38skcck4ndg3b">
              Kennisbank
            </a>
            <span className="text-navy-500" data-id="element-2326" data-mp="3io402j9258gz">/</span>
            <span className="text-accent-light font-medium" data-id="element-2327" data-mp="j0ukxf6iug1">
              Laten maken of zelf bouwen
            </span>
          </nav>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-2328" data-mp="3rok17m2bw3io">
            Website laten maken of zelf bouwen?
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-2329" data-mp="59h80hj02g2e">
            De voor- en nadelen van beide opties op een rij. Ontdek welke keuze
            het beste past bij jouw situatie.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-2330" data-mp="ecie4i7v8762">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-2331" data-mp="xw7hqpfepd0x">
              Vraag advies
              <ArrowRightIcon className="w-5 h-5" data-id="element-2332" data-mp="svt7d0qc1qzq" />
            </a>
          </div>
        </div>
      </section>

      {/* Zelf een website maken */}
      <section className="py-24 bg-surface-muted" data-id="element-2333" data-mp="jwfwc3mk8ucw">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2334" data-mp="jyaj7nhe6wjm">
          <div className="text-center mb-16" data-id="element-2335" data-mp="58l2ul0qalyr">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2336" data-mp="59mo1ibgkou7">
              Zelf een website maken
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2337" data-mp="3scrj87x9q0fl">
              Met een website builder zoals Wix of Squarespace kun je zelf aan
              de slag. Dit zijn de voor- en nadelen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-2338" data-mp="22wfffpyp830b">
            {/* Voordelen */}
            <div data-id="element-2339" data-mp="1y3vto5puy1kf">
              <h3 className="text-xl font-bold text-navy-900 mb-6 flex items-center gap-2" data-id="element-2340" data-mp="1y3cn1l5nqzlp">
                <span className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-2341" data-mp="1t644hjglktjx">
                  <CheckIcon className="w-5 h-5" data-id="element-2342" data-mp="1p1wcndeuexhh" />
                </span>
                Voordelen
              </h3>
              <div className="space-y-4" data-id="element-2343" data-mp="2gv5dp8x988q9">
                <div className="bg-white rounded-card shadow-soft p-6" data-id="element-2344" data-mp="2gw81v936zx2h">
                  <h4 className="font-bold text-navy-900 mb-2 flex items-center gap-2" data-id="element-2345" data-mp="2ct20aer0yu2c">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-2346" data-mp="27uqqg40qcjk4" />
                    Goedkoper
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-2347" data-mp="11fg4wbuknw8d">
                    Website builders starten al vanaf €10 per maand. Ideaal als
                    je een beperkt budget hebt.
                  </p>
                </div>
                <div className="bg-white rounded-card shadow-soft p-6" data-id="element-2348" data-mp="380u5vp5b3f34">
                  <h4 className="font-bold text-navy-900 mb-2 flex items-center gap-2" data-id="element-2349" data-mp="3d29q5eznthkg">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-2350" data-mp="3h2jzn1mnuq42" />
                    Snelle start
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-2351" data-mp="3lvwnh9jimsvr">
                    Binnen een paar uur heb je een werkende website online met
                    kant-en-klare templates.
                  </p>
                </div>
                <div className="bg-white rounded-card shadow-soft p-6" data-id="element-2352" data-mp="4losguchaawn">
                  <h4 className="font-bold text-navy-900 mb-2 flex items-center gap-2" data-id="element-2353" data-mp="8n9zw068twzg">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-2354" data-mp="26dba45ahctgg" />
                    Veel templates
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-2355" data-mp="2afy6mji3j2jz">
                    Kies uit honderden templates en pas ze aan naar jouw smaak
                    zonder technische kennis.
                  </p>
                </div>
              </div>
            </div>

            {/* Nadelen */}
            <div data-id="element-2356" data-mp="209wxe3u1g8jw">
              <h3 className="text-xl font-bold text-navy-900 mb-6 flex items-center gap-2" data-id="element-2357" data-mp="20agi1sb2pb1m">
                <span className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center text-red-600" data-id="element-2358" data-mp="1w9wk4mioe3ef">
                  <XIcon className="w-5 h-5" data-id="element-2359" data-mp="18k27a4ycweu6" />
                </span>
                Nadelen
              </h3>
              <div className="space-y-4" data-id="element-2360" data-mp="13ms6xu9fiirk">
                <div className="bg-white rounded-card shadow-soft p-6" data-id="element-2361" data-mp="1hkqm31vkqj84">
                  <h4 className="font-bold text-navy-900 mb-2 flex items-center gap-2" data-id="element-2362" data-mp="1cldphpewhxsc">
                    <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-2363" data-mp="1cnqfmputbegh" />
                    Beperkte flexibiliteit
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-2364" data-mp="2o1c6qgk8fq4n">
                    Je zit vast aan de mogelijkheden van het platform. Maatwerk
                    is vaak niet mogelijk.
                  </p>
                </div>
                <div className="bg-white rounded-card shadow-soft p-6" data-id="element-2365" data-mp="30khf1umkwq2e">
                  <h4 className="font-bold text-navy-900 mb-2 flex items-center gap-2" data-id="element-2366" data-mp="2mkoukh1nb62v">
                    <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-2367" data-mp="2rjjclgrsgqlx" />
                    SEO vaak zwakker
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-2368" data-mp="3f8udqzd1wn0l">
                    Website builders bieden beperkte SEO-opties, waardoor je
                    minder goed vindbaar bent in Google.
                  </p>
                </div>
                <div className="bg-white rounded-card shadow-soft p-6" data-id="element-2369" data-mp="3agsz56seuk7e">
                  <h4 className="font-bold text-navy-900 mb-2 flex items-center gap-2" data-id="element-2370" data-mp="21iy8209bl17">
                    <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-2371" data-mp="1zpqejdwqurm" />
                    Technische kennis nodig
                  </h4>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-2372" data-mp="2xf93h9igyh47">
                    Ondanks de eenvoud loop je al snel tegen technische
                    beperkingen aan bij aanpassingen.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Website laten maken */}
      <section className="py-24 bg-white" data-id="element-2373" data-mp="2tfqhsbitq20b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2374" data-mp="2eorftjchubpp">
          <div className="text-center mb-16" data-id="element-2375" data-mp="2jfpw4ixhf9sy">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2376" data-mp="2jghsvx2tfdkt">
              Website laten maken door een professional
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2377" data-mp="29pwm3mczn2qt">
              Een webdesigner bouwt een website die volledig is afgestemd op
              jouw bedrijf en doelen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2378" data-mp="20prog3xljipu">
            <div className="bg-surface-muted p-8 rounded-card border border-navy-100" data-id="element-2379" data-mp="20r2ru2n4qogf">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2380" data-mp="1h5j0yaguheeb">
                <CheckIcon className="w-6 h-6 text-accent" data-id="element-2381" data-mp="1c6g43db0qehf" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2382" data-mp="1r2xhea2rq36m">
                Professioneel design
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2383" data-mp="1m4vx5ltlvxtk">
                Een uniek ontwerp dat past bij jouw merk en vertrouwen wekt bij
                bezoekers. Geen standaard template.
              </p>
            </div>

            <div className="bg-surface-muted p-8 rounded-card border border-navy-100" data-id="element-2384" data-mp="29sn8on7bo6ts">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2385" data-mp="24taqifrebnxj">
                <CheckIcon className="w-6 h-6 text-accent" data-id="element-2386" data-mp="2isacffnixoq0" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2387" data-mp="2er6zp20rw8t0">
                SEO-optimalisatie
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2388" data-mp="2luwxp0u411c8">
                Technische SEO, snelheid en contentoptimalisatie zorgen ervoor
                dat je beter gevonden wordt in Google.
              </p>
            </div>

            <div className="bg-surface-muted p-8 rounded-card border border-navy-100" data-id="element-2389" data-mp="2vrt1wucz71az">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2390" data-mp="30kclq929aso8">
                <CheckIcon className="w-6 h-6 text-accent" data-id="element-2391" data-mp="34k3ay8c4x0qn" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2392" data-mp="39j6gdtw118z5">
                Volledig maatwerk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2393" data-mp="3ekdlfl6sbu24">
                Van functionaliteiten tot koppelingen: alles wordt gebouwd op
                basis van jouw specifieke wensen en doelen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Wanneer kies je wat */}
      <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-2394" data-mp="1p4eabyjlvuju">
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-2395" data-mp="6a1lv8uyzif2" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2396" data-mp="3omzib5sjzt4h">
          <div className="text-center mb-16" data-id="element-2397" data-mp="3oou04b8j354c">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-2398" data-mp="p8dwz05fz2da">
              Wanneer kies je wat?
            </h2>
            <p className="text-lg text-navy-300 max-w-2xl mx-auto" data-id="element-2399" data-mp="l7lnc5snqvgh">
              De juiste keuze hangt af van jouw situatie, budget en ambities.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2400" data-mp="b8w2c45gsuw0">
            <div className="bg-white/[0.06] border border-white/10 rounded-2xl p-8" data-id="element-2401" data-mp="30xevucx6ydqg">
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center mb-6" data-id="element-2402" data-mp="30v25bbddav1s">
                <UserIcon className="w-6 h-6 text-white" data-id="element-2403" data-mp="2w0og5qpatk5k" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-2404" data-mp="noce88ag26rx">ZZP'er</h3>
              <p className="text-navy-300 leading-relaxed" data-id="element-2405" data-mp="sh5herq9l71w">
                Als zzp'er met een beperkt budget kan een website builder een
                goede start zijn. Wil je groeien en meer klanten aantrekken? Dan
                loont een professionele website zich snel.
              </p>
            </div>

            <div className="bg-white/[0.06] border border-white/10 rounded-2xl p-8" data-id="element-2406" data-mp="17e4jk02ck7oz">
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center mb-6" data-id="element-2407" data-mp="1bdwxksaif61q">
                <BuildingIcon className="w-6 h-6 text-white" data-id="element-2408" data-mp="xengzrie69x8" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-2409" data-mp="12dgvnn9f06yz">MKB</h3>
              <p className="text-navy-300 leading-relaxed" data-id="element-2410" data-mp="3i5xplrxl5amq">
                Voor mkb-bedrijven is een professionele website vrijwel altijd
                de betere keuze. Je hebt meer pagina's nodig, betere SEO en een
                betrouwbare uitstraling die past bij je merk.
              </p>
            </div>

            <div className="bg-white/[0.06] border border-white/10 rounded-2xl p-8" data-id="element-2411" data-mp="3amy6lne1dl3w">
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center mb-6" data-id="element-2412" data-mp="3olo77d02e2x0">
                <TrendingUpIcon className="w-6 h-6 text-white" data-id="element-2413" data-mp="3jmbjkq1dcrtd" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-2414" data-mp="2vx8u4w0htuob">
                Groeiend bedrijf
              </h3>
              <p className="text-navy-300 leading-relaxed" data-id="element-2415" data-mp="2rw6zkshiu6so">
                Groeit je bedrijf? Dan heb je een schaalbare website nodig met
                maatwerk, koppelingen en doorlopend onderhoud. Een website
                builder schiet dan tekort.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-white border-b border-navy-100" data-id="element-2416" data-mp="2d4epauwl3ixt">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2417" data-mp="2874xj8lq2v6t">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-2418" data-mp="c3i1o91squds">
            Ontdek meer:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-2419" data-mp="h2bhw98gwzhn">
            <a href="#/website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2420" data-mp="ltt9w7sijpqh">
              Website laten maken
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2421" data-mp="3pc39tg2occcf">•</span>
            <a href="#/wordpress-websites" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2422" data-mp="3u9wkomex9uj1">
              WordPress websites
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2423" data-mp="76hx62klhzos">•</span>
            <a href="#/kosten-website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2424" data-mp="1eja8xoan24vo">
              Kosten website laten maken
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-surface-muted" data-id="element-2425" data-mp="2z1b23tb39nro">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2426" data-mp="2z1kpd94r1gto">
          <div className="text-center mb-16" data-id="element-2427" data-mp="2u9j6v5gzmtv7">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2428" data-mp="2u8851b73rw6q">
              Veelgestelde vragen
            </h2>
          </div>

          <div className="space-y-4" data-id="element-2429" data-mp="2kcevm0ookit6">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-soft overflow-hidden" data-id="element-2430" data-mp="2fdbpse0vm8k5" data-mpi={index}>
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-2431" data-mp="2bc9n1n7r3edf">
                  <span className="font-bold text-navy-900" data-id="element-2432" data-mp="9isfejjmedio">{faq.q}</span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-2433" data-mp="4ls9q9qoncs3" /> : <ChevronDownIcon className="w-5 h-5 text-navy-400 flex-shrink-0" data-id="element-2434" data-mp="39n5cxk85kkke" />}
                </button>
                {openFaq === index && <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-2435" data-mp="2zug5d0fq3quc">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-2436" data-mp="2uw6a6pu00q8q" />
    </main>;
}